<div class="signup customer-area">
  <h1>Área do Cliente</h1>

  @switch (stage) {
    @case ('loading') {
      <p class="text-center">Carregando...</p>
    }

    @case ('login') {
      <div class="card-form">
        <h2>Entre na sua conta</h2>
        <p class="fine">A mesma conta do cadastro em ncommerce.app. Ela não é o usuário do sistema da loja.</p>
        <app-google-button (credential)="googleSignIn($event)"></app-google-button>
        <p class="or">ou com e-mail e senha</p>
        <form (ngSubmit)="signIn()">
          <label class="form-label" for="ca-email">E-mail</label>
          <input id="ca-email" class="form-control" name="email" type="email" [(ngModel)]="email" autocomplete="email">
          <label class="form-label" for="ca-password">Senha</label>
          <input id="ca-password" class="form-control" name="password" type="password" [(ngModel)]="password" autocomplete="current-password">
          <button class="btn btn-primary btn-lg w-100" type="submit" [disabled]="loading">{{ loading ? 'Entrando...' : 'Entrar' }}</button>
        </form>
        @if (error) { <p class="error">{{ error }}</p> }
        <p class="fine">Ainda não tem conta? <a routerLink="/cadastro">Faça o cadastro</a>. Esqueceu a senha? Escreva
          para contato&#64;ncommerce.app.</p>
      </div>
    }

    @case ('overview') {
      <p class="text-center">Olá, {{ area?.owner?.name }}!</p>
      @if (notice) { <p class="success">{{ notice }}</p> }
      @if (error && !editing) { <p class="error">{{ error }}</p> }

      @for (c of area?.companies; track c.name) {
        <div class="card-form company">
          <div class="company-head">
            <div>
              <h2>{{ c.nome_fantasia }}</h2>
              <div class="fine">Plano <strong>{{ plan(c.plan)?.name || 'personalizado' }}</strong>
                @if (plan(c.plan); as p) { · {{ p.price === 0 ? 'Grátis' : 'R$ ' + p.price + '/mês' }} }</div>
            </div>
            <span class="badge-status" [class.ok]="c.installed">{{ c.installed ? 'Instalado' : 'Aguardando instalação' }}</span>
          </div>

          @switch (c.payment) {
            @case ('waiting_install') {
              <p class="warning">O pagamento só começa depois da instalação. Quando o sistema estiver funcionando e com o
                acesso remoto ligado, mandamos o link de pagamento para o seu e-mail e WhatsApp.</p>
            }
            @case ('overdue') {
              <div class="overdue">
                <p class="mb-2"><strong>Mensalidade vencida.</strong>
                  @if (c.card_autopay) { O cartão foi recusado. } Pague por PIX, boleto ou cartão para continuar em dia.</p>
                @if (c.payment_url) {
                  <a class="btn btn-danger" [href]="c.payment_url" target="_blank" rel="noopener">Pagar agora</a>
                }
              </div>
            }
            @case ('open') {
              @if (c.card_autopay) {
                <p class="success">Débito automático no cartão ativo: a mensalidade é cobrada todo mês no seu cartão.</p>
              } @else {
                <div class="warning">
                  <p class="mb-2">Sistema instalado! A fatura do Plano {{ plan(c.plan)?.name }} está aberta: pague por PIX,
                    boleto ou cartão.</p>
                  @if (c.payment_url) {
                    <a class="btn btn-success" [href]="c.payment_url" target="_blank" rel="noopener">Pagar agora</a>
                  } @else {
                    <p class="fine mb-0">Mandamos o link de pagamento para o seu e-mail e WhatsApp.</p>
                  }
                </div>
              }
            }
          }
          @if (c.plan_paid_until) {
            <p class="fine">Pago até {{ c.plan_paid_until | date:'dd/MM/yyyy' }}.</p>
          }
          @if (!c.card_autopay && (c.payment === 'open' || c.payment === 'overdue' || (c.plan_paid_until && (plan(c.plan)?.price || 0) > 0))) {
            <div class="autopay">
              <button class="btn btn-outline-success" type="button" [disabled]="loading" (click)="cardAutopay(c)">
                Ativar débito automático no cartão
              </button>
              <p class="fine mb-0">Você cadastra o cartão na página segura do Asaas e a mensalidade passa a ser cobrada
                sozinha todo mês. @if (c.payment === 'open') { A fatura aberta é cobrada no cartão no vencimento e sai da lista. }</p>
            </div>
          } @else if (c.card_autopay && c.payment !== 'open') {
            <p class="fine">Débito automático no cartão ativo.</p>
          }

          @if (editing === c.name) {
            <div class="plans">
              @for (p of area?.plans; track p.key) {
                <button type="button" class="plan" [class.selected]="selectedPlan === p.key" (click)="selectedPlan = p.key">
                  <app-plan-card [plan]="p"></app-plan-card>
                  @if (p.key === c.plan) { <span class="current">Plano atual</span> }
                </button>
              }
            </div>
            <div class="actions">
              <button class="btn btn-outline-secondary" type="button" (click)="cancelChange()">Cancelar</button>
              <button class="btn btn-primary" type="button" [disabled]="loading || !selectedPlan || selectedPlan === c.plan"
                (click)="confirmChange(c)">{{ loading ? 'Salvando...' : 'Confirmar mudança' }}</button>
            </div>
            @if (error) { <p class="error">{{ error }}</p> }
          } @else {
            <button class="btn btn-outline-primary" type="button" (click)="startChange(c)">Ver e mudar o plano</button>
          }
        </div>
      } @empty {
        <div class="card-form">
          <p>Você ainda não tem estabelecimento com o cadastro concluído.</p>
        </div>
      }

      @if (area?.signup_in_progress) {
        <p class="fine text-center">Você tem um cadastro em andamento. Para continuar, abra o link que mandamos por e-mail e
          WhatsApp (ou <a routerLink="/cadastro">peça um novo</a>).</p>
      } @else {
        <p class="fine text-center"><a routerLink="/cadastro">Cadastrar outro estabelecimento</a></p>
      }

      <p class="fine text-center">
        Conectado como {{ area?.owner?.email }} ·
        <button class="btn btn-link btn-sm p-0 align-baseline" type="button" (click)="signOut()">sair</button>
      </p>
    }
  }
</div>
